import React from 'react'

import { mq } from 'marketing-site/src/library/utils'
import { IHeaderNavigationSolution } from '../'
import { CTALink } from 'marketing-site/src/mvp/library/elements/CTALink'
import { Text } from 'marketing-site/src/library/elements/Text'

export const HeaderNavigationSolution = ({
  contentType = 'flex',
  eyebrow,
  title,
  subhead,
  cta,
  secondCta,
  additionalTitle,
  additionalSubhead,
  additionalCTA,
}: IHeaderNavigationSolution): React.ReactElement => {
  return (
    <>
      <div className="header-navigation-solution">
        {eyebrow && (
          <div className="header-navigation-solution__eyebrow">
            <Text
              brand={contentType === 'flex' ? 'default' : 'mvp'}
              size={contentType === 'flex' ? 'eyebrows' : 'eyebrow'}
            >
              {eyebrow}
            </Text>
          </div>
        )}
        <div className="header-navigation-solution__title">
          <Text brand={contentType === 'flex' ? 'default' : 'mvp'} size="heading-3">
            {title}
          </Text>
        </div>
        <div className="header-navigation-solution__subhead">
          <Text brand={contentType === 'flex' ? 'default' : 'mvp'} size="body">
            {subhead}
          </Text>
        </div>
        <div className="header-navigation-solution__ctas">
          <div className="header-navigation-solution__cta">
            <CTALink {...cta} />
          </div>
          {secondCta && (
            <div className="header-navigation-solution__second-cta">
              <CTALink {...secondCta} />
            </div>
          )}
        </div>
        {additionalTitle && (
          <div className="header-navigation-solution__additional-title">
            <Text brand={contentType === 'flex' ? 'default' : 'mvp'} size="heading-3">
              {additionalTitle}
            </Text>
          </div>
        )}
        {additionalSubhead && (
          <div className="header-navigation-solution__subhead">
            <Text brand={contentType === 'flex' ? 'default' : 'mvp'} size="body">
              {additionalSubhead}
            </Text>
          </div>
        )}
        {additionalCTA && (
          <div className="header-navigation-solution__additional-cta">
            <CTALink {...additionalCTA} />
          </div>
        )}
      </div>

      <style jsx>{`
        .header-navigation-solution {
          &__eyebrow {
            margin-bottom: 1.5rem;
          }

          &__subhead {
            margin-top: 0.75rem;
          }

          &__ctas {
            margin-top: 0.75rem;
          }

          &__second-cta {
            margin-top: 1rem;
          }

          &__additional-title {
            margin-top: 2.5rem;
          }

          &__additional-cta {
            margin-top: 0.75rem;
          }
        }

        @media (${mq.desktop}) {
          .header-navigation-solution {
            max-width: calc(50% - 2rem);

            &__ctas {
              display: flex;
            }

            &__second-cta {
              margin-top: 0;
              margin-left: 1rem;
            }
          }
        }
      `}</style>
    </>
  )
}
